
import React, { useState, useEffect } from 'react';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import InputSwitchElement from '../../../../Components/UiComponents/InputSwitchElement';

const Portfolio = (props) => {

	const [fields, setFields] = useState([]);
	const [field, setField] = useState([]);

	useEffect(() => {
		const extractedData = extractFieldNamesAndTexts(props?.fields)
		setFields(extractedData)
		setField(props?.fields)
	}, [props.fields]);


	const extractFieldNamesAndTexts = (response) => {
		const result = [];
		const extract = (obj, key) => {
			if (obj.field_name && obj.text && key != undefined) {
				result.push({
					index: obj.index,
					field_name: obj.field_name,
					ESG_field_name: obj.ESG_field_name,
					text: obj.text,
					status: obj.status,
					key: key
				});
			}
			Object.entries(obj).forEach(([key, value]) => {
				if (typeof value === 'object' && value !== null) {
					extract(value, key);
				}
			});
		};

		extract(response);
		return result;
	};

	const arrayToObjectAndRemoveKey = (array, key, removeKey) => {
		return array.reduce((obj, item) => {
			const { [removeKey]: _, ...rest } = item;  // Destructure and exclude the removeKey
			obj[item[key]] = rest;  // Assign the rest of the item to the new object
			return obj;
		}, {});
	};


	// Function to toggle field_status
	const handleFieldToggle = (index) => {
		var res = fields.map((field, i) =>
			i === index ? { ...field, status: !field.status } : field
		);
		setFields(res)

		const result = arrayToObjectAndRemoveKey(res, 'key', 'key');

		props.getData(result);
	};

	const handlePlaceholderChange = (index, value) => {
		const res = fields.map((field, i) =>
			i === index ? { ...field, text: value } : field
		);
		setFields(res)

		const result = arrayToObjectAndRemoveKey(res, 'key', 'key');

		props.getData(result);
		// updateResponse(updatedFields)

	};

	const updateResponse = (updatedValues) => {
		const newResponse = { ...field };

		updatedValues.forEach((updatedItem) => {
			const index = updatedItem.index;
			const fieldToUpdate = Object.keys(newResponse).find(key => newResponse[key].index === index);
			if (fieldToUpdate) {
				newResponse[fieldToUpdate] = updatedItem;
			}

			props.getData(newResponse);
		});
	};

	return (
		<div className="new-field">
			{fields.map((field, index) => (
				<div className="new-field" key={index}>
					<div className="form-group row align-items-center mb-0 mt-0" >
						<div className='col-md-4 pl-0'>
							<label htmlFor={`field-${index}`} className="p-label">{field.ESG_field_name}:</label>
						</div>
						<div className="col-md-1 pl-0" >
							<InputSwitchElement checked={field?.status} onChange={() => handleFieldToggle(index)} />
						</div>
						<div className='col pr-0'>
							<InputTextElementElement
								// key={index}
								disabled={!field?.status}
								value={field.text}
								onChange={(e) => handlePlaceholderChange(index, e.target.value)}
								placeholder={field.placeholder}
								className='w-full'
							/>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default Portfolio;
